import { useState, useEffect } from 'react';

import Papa from 'papaparse';

import { ADMIN } from '@common/network/ApiPaths';
import {
  UPLOAD_TOAST_INITIAL_STATE,
  UPLOAD_TOAST_SUCCESS_STATE,
  REPLACE_TOAST_SUCCESS_STATE,
  UPLOAD_TOAST_ERROR_STATE
} from '@common/toastConstants';
import { getByPathAndParams, postByPathAndData } from '@services/BaseApi';



import { transformProductLimitsHeaders } from './utils';

const useProductLimitsPanel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [listOfProductLimits, setListOfProductLimits] = useState([]);
  const [uploadIsLoading, setUploadIsLoading] = useState(false);
  const [uploadToastState, setUploadToastState] = useState(
    UPLOAD_TOAST_INITIAL_STATE
  );

  const onUpload = (event, type) => {
    const files = event.target.files;

    if (files) {
      setUploadIsLoading(true);

      Papa.parse(files[0], {
        header: true,
        skipEmptyLines: true,
        transformHeader: transformProductLimitsHeaders,
        error: function () {
          setUploadIsLoading(false);
          setUploadToastState(UPLOAD_TOAST_ERROR_STATE);
        },
        complete: async function (results) {
          try {
            const path =
              type === 'upsert'
                ? ADMIN.UPSERT_PRODUCT_LIMITS
                : ADMIN.REPLACE_PRODUCT_LIMITS;
            await postByPathAndData({
              path,
              data: results.data
            });

            if (type === 'upsert')
              setUploadToastState(UPLOAD_TOAST_SUCCESS_STATE);
            else setUploadToastState(REPLACE_TOAST_SUCCESS_STATE);
            await fetchProductLimits();
          } catch ({ response }) {
            setUploadToastState({
              ...UPLOAD_TOAST_ERROR_STATE,
              message: response?.data?.message
            });
          } finally {
            event.target.value = '';
            setUploadIsLoading(false);
          }
        }
      });
    }
  };

  const setUploadToastToInitial = () => {
    setUploadToastState(UPLOAD_TOAST_INITIAL_STATE);
  };

  const fetchProductLimits = async () => {
    try {
      setIsLoading(true);
      let { data } = await getByPathAndParams({
        path: ADMIN.GET_PRODUCT_LIMITS
      });
      setListOfProductLimits(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProductLimits();
  }, []);

  return [
    listOfProductLimits,
    isLoading,
    onUpload,
    uploadIsLoading,
    uploadToastState,
    setUploadToastToInitial
  ];
};

export default useProductLimitsPanel;
